var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-list"},[_c('p',{staticClass:"month-title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.listData),function(item,index){return _c('div',{key:index,staticClass:"live-item-parent"},[_c('live-item',{attrs:{"itemData":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }